<ion-content data-cy="Quote supply entries" class="ion-padding">
  <div *ngIf="isRemainingAmountWarningActive" class="supply-entries-warning ion-margin-bottom" role="status">
    <ion-icon name="alert-circle" class="supply-entries-warning__icon" aria-hidden="true"></ion-icon>
    <div class="supply-entries-warning__text fs-14 font-medium ion-text-wrap">
      {{ 'pages.quotes.supplyEntries.warning.completedAndInvoicedRDA' | translate }}
    </div>
  </div>

  <div class="text-center" *ngIf="!isSupplyEntryEnabled">
    {{ 'pages.quotes.supplyEntries.noData' | translate }}
  </div>

  <div *ngIf="isSupplyEntryEnabled">
    <div class="flex ion-justify-content-between">
      <span class="ion-text-uppercase">{{ 'pages.quotes.supplyEntries.list.title' | translate }}</span>
      <span class="ion-text-uppercase">{{ 'pages.quotes.supplyEntries.list.quantity' | translate }}</span>
    </div>
    <br />
    <div *ngIf="(supplyEntries | async)?.length === 0" class="text-center font-regular ion-margin-top ion-padding-vertical">
      {{ 'pages.quotes.supplyEntries.list.empty' | translate }}
    </div>
    <ion-item
      button="true"
      *ngFor="let supplyEntry of supplyEntries | async; let index"
      class="ion-align-items-center ion-margin-top supply-entry ion-no-padding"
      (click)="openDetail(supplyEntry)"
    >
      <ion-icon class="attachment-icon" name="attach-outline" *ngIf="supplyEntry.fileUrl"></ion-icon>
      <span class="date">{{ supplyEntry.arrivalDate | date }}</span>
      <span class="quantity" slot="end">{{ supplyEntry.quantity }}</span>
    </ion-item>
    <br /><br />
    <h4 class="ion-text-right text-lg ion-margin-top">
      {{ 'pages.quotes.supplyEntries.list.total' | translate }}&nbsp;{{ supplyEntriesQuantity }}/{{ totalQuantity }}
    </h4>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      expand="block"
      data-cy="Add supply entry"
      class="x-16 b-16 ion-color-white"
      (click)="addSupplyEntry()"
      mode="ios"
      [disabled]="!isSupplyEntryEnabled || !canEditSupplyEntries || isLimitReached"
    >
      {{ 'pages.quotes.supplyEntries.add' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
